import React, { useState, useEffect } from "react";
import Close from "../../../images/close-white.png";
import PropTypes from 'prop-types';

const RemoveInReviewPostModal = ({handleRemoveInReviewPost, loadingRemovingInReviewPost}) => {
  RemoveInReviewPostModal.propTypes = {
    handleRemoveInReviewPost: PropTypes.func.isRequired,
    loadingRemovingInReviewPost: PropTypes.bool.isRequired
  };

  return (
    <div
      className="modal fade"
      id="removeInReviewPostModal"
      tabIndex="-1"
      aria-labelledby="removeInReviewPostModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="removeInReviewPostModalLabel">
              Are you sure?
            </h5>

            <img
              src={Close}
              alt="close"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              width="50px"
              style={{ cursor: "pointer" }}
              id="removeInReviewPostModalClose"
            />
          </div>
          <div className="modal-body">
            <p style={{ marginBottom: 25 }}>Do you want to completely remove this account?</p>
          </div>
          <div className="modal-footer border-0 p-2">
            <button type="button" className="btn" data-dismiss="modal">
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleRemoveInReviewPost}
              style={{ width: 95 }}
            >
              {loadingRemovingInReviewPost ? (
                <div className="spinner-border spinner-border-sm" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              ) : (
                "Yes"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RemoveInReviewPostModal;
